const initialState = () => ({
  interest: {
    duration: null,
    startDate: '',
    endDate: '',
  },

  identity: {
    lastName: '',
    firstName: '',
    birthDate: '',
    gender: null,
    nationality: '',
  },

  contact: {
    email: '',
    mobile: '',
    ice: '',
  },

  bank: {
    name: '',
    holder: '',
    iban: '',
    bic: '',
  },

  address: {
    street: '',
    postalCode: '',
    city: '',
    country: '',
  },

  housing: {
    exist: false,
    street: '',
    postalCode: '',
    city: '',
  },

  cursus: {
    level: null,
    language: null,
    otherLanguage: '',
    country: '',
    company: '',
  },

  scholarship: null,

  motivation: '',

  poll: [],
  pollOther: '',
});

export default {
  namespaced: true,

  state: initialState(),

  mutations: {
    SET_INTEREST(state, data) {
      state.interest[data.key] = data.value;
    },

    SET_IDENTITY(state, data) {
      state.identity[data.key] = data.value;
    },

    SET_CONTACT(state, data) {
      state.contact[data.key] = data.value;
    },

    SET_BANK(state, data) {
      state.bank[data.key] = data.value;
    },

    SET_ADDRESS(state, data) {
      state.address[data.key] = data.value;
    },

    SET_HOUSING(state, data) {
      state.housing[data.key] = data.value;
    },

    SET_CURSUS(state, data) {
      state.cursus[data.key] = data.value;
    },

    SET_SCHOLARSHIP(state, data) {
      state.scholarship = data;
    },

    SET_MOTIVATION(state, data) {
      state.motivation = data;
    },

    SET_POLL(state, data) {
      state.poll = data;
    },

    SET_POLL_OTHER(state, data) {
      state.pollOther = data;
    },

    RESET_STATE(state) {
      Object.assign(state, initialState());
    },
  },

  actions: {
    importStudentData({ state, commit }, data) {
      const studentKeys = {
        identity: Object.keys(state.identity),
        contact: Object.keys(state.contact),
        bank: Object.keys(state.bank),
        address: Object.keys(state.address),
        housing: Object.keys(state.housing),
      };
      const studentProps = Object.keys(studentKeys);
      const dataEntries = Object.entries(data);

      dataEntries.forEach((entry) => {
        if (studentProps.includes(entry[0])) {
          Object.keys(entry[1]).forEach((key) => {
            if (studentKeys[entry[0]].includes(key)) {
              commit(`SET_${entry[0].toUpperCase()}`, { key, value: entry[1][key] });
            }
          });
        }
      });

      commit('SET_HOUSING', {
        key: 'exist',
        value: studentKeys.housing.every((key) => state.housing[key] != null),
      });
    },
  },
};
